import { createElement } from "@wordpress/element";

const ToolbarButtonContainer = props => createElement("div", {
  className: props.className
}, props.children);

export default ToolbarButtonContainer;
//# sourceMappingURL=toolbar-button-container.js.map